import {useRef, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, p, position} from "@pg-design/helpers-css";
import {CrmFlagIcon, DotsVerticalIcon} from "@pg-design/icons-module";

import {useClickOutside} from "../../hooks/handle_click_outside";
import {ReportContentModal} from "./ReportContentModal";

interface IProps {
    className?: string;
    onToggle?: (isOpen: boolean) => void;
}

export const DetailHeaderDropdownMenu = (props: IProps) => {
    const {className, onToggle} = props;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);
    useClickOutside(wrapperRef, () => setIsMenuOpen(false));

    const handleToggle = () => {
        setIsMenuOpen((prev) => !prev);
        if (onToggle) {
            onToggle(isMenuOpen);
        }
    };

    return (
        <>
            <div className={className} css={menuWrap} onClick={handleToggle} ref={wrapperRef}>
                <Button variant="none_secondary" css={menuButton} size="x-small">
                    <DotsVerticalIcon size="2.2" wrapperColor="transaprent" wrapperSize="2.2" />
                </Button>
                {isMenuOpen && (
                    <div css={buttonWrap}>
                        <Button variant="none_secondary" iconLeft={CrmFlagIcon} onClick={() => setIsReportModalOpen(true)} css={itemButton}>
                            Zgłoś treść
                        </Button>
                    </div>
                )}
            </div>
            <ReportContentModal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} />
        </>
    );
};

const menuWrap = css`
    position: relative;
`;

const menuButton = css`
    max-width: 40px;
    ${elevation(1)};
    ${position("relative")};
`;

const buttonWrap = css`
    ${p(2)};
    background-color: #fff;
    ${borderRadius(1)};
    ${elevation(4)};
    ${position("absolute")};
    right: 0;
    bottom: -${calculateRemSize(2.5)};
    transform: translateY(100%);
    z-index: 12;
`;

const itemButton = css`
    ${p(1.5, 2)};
    height: ${calculateRemSize(6)};
`;
import {useRef, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, p, position} from "@pg-design/helpers-css";
import {CrmFlagIcon, DotsVerticalIcon} from "@pg-design/icons-module";

import {useClickOutside} from "../../hooks/handle_click_outside";
import {ReportContentModal} from "./ReportContentModal";

interface IProps {
    className?: string;
    onToggle?: (isOpen: boolean) => void;
}

export const DetailHeaderDropdownMenu = (props: IProps) => {
    const {className, onToggle} = props;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);
    useClickOutside(wrapperRef, () => setIsMenuOpen(false));

    const handleToggle = () => {
        setIsMenuOpen((prev) => !prev);
        if (onToggle) {
            onToggle(isMenuOpen);
        }
    };

    return (
        <>
            <div className={className} css={menuWrap} onClick={handleToggle} ref={wrapperRef}>
                <Button variant="none_secondary" css={menuButton} size="x-small">
                    <DotsVerticalIcon size="2.2" wrapperColor="transaprent" wrapperSize="2.2" />
                </Button>
                {isMenuOpen && (
                    <div css={buttonWrap}>
                        <Button variant="none_secondary" iconLeft={CrmFlagIcon} onClick={() => setIsReportModalOpen(true)} css={itemButton}>
                            Zgłoś treść
                        </Button>
                    </div>
                )}
            </div>
            <ReportContentModal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} />
        </>
    );
};

const menuWrap = css`
    position: relative;
`;

const menuButton = css`
    max-width: 40px;
    ${elevation(1)};
    ${position("relative")};
`;

const buttonWrap = css`
    ${p(2)};
    background-color: #fff;
    ${borderRadius(1)};
    ${elevation(4)};
    ${position("absolute")};
    right: 0;
    bottom: -${calculateRemSize(2.5)};
    transform: translateY(100%);
    z-index: 12;
`;

const itemButton = css`
    ${p(1.5, 2)};
    height: ${calculateRemSize(6)};
`;
